export default "__VITE_ASSET__K2S9Jpt7__"